"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_VALUES = exports.UPDATE_ERRORS = exports.SET_VALUES = exports.SET_REGISTERED_FIELDS = exports.SET_ERRORS = exports.RESET_FORM = exports.INITIALIZE_FORM = exports.GET_VALUES = exports.GET_ERRORS = exports.DELETE_FORM = exports.CHANGE_VALUE = void 0;
/**
 * Common actions
 *
 */
const UPDATE_ERRORS = exports.UPDATE_ERRORS = 'UPDATE_ERRORS';
const GET_ERRORS = exports.GET_ERRORS = 'GET_ERRORS';
const SET_ERRORS = exports.SET_ERRORS = 'SET_ERRORS';
const UPDATE_VALUES = exports.UPDATE_VALUES = 'UPDATE_VALUES';
const GET_VALUES = exports.GET_VALUES = 'GET_VALUES';
const SET_VALUES = exports.SET_VALUES = 'SET_VALUES';
const INITIALIZE_FORM = exports.INITIALIZE_FORM = 'INITIALIZE_FORM';
const CHANGE_VALUE = exports.CHANGE_VALUE = 'CHANGE_VALUE';
const RESET_FORM = exports.RESET_FORM = 'RESET_FORM';
const DELETE_FORM = exports.DELETE_FORM = 'DELETE_FORM';
const SET_REGISTERED_FIELDS = exports.SET_REGISTERED_FIELDS = 'SET_REGISTERED_FIELDS';